import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Delete, ShoppingBag } from "@mui/icons-material";
import { useCart } from "../../context/CartContext";
import { getCartItems } from '../../actions/cartActions'
import ProductSlider from "../../components/ProductSlider/ProductSlider";
import { fetchMeta } from "../../actions/metaActions";
import { Helmet } from "react-helmet-async";
import "./Cart.css";

export default function Cart() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { cartItems: items, updateItem, removeItem } = useCart();
    const { cartItems, subtotal, total, error, loading } = useSelector(state => state.cartState);
    const { meta, loading: metaLoading } = useSelector((state) => state.metaState);

    useEffect(() => {
        dispatch(fetchMeta('cart'));
    }, [dispatch]);


    useEffect(() => {
        if (items)
            dispatch(getCartItems(items));
    }, [dispatch, items]);

    const goToCheckout = () => {
        navigate("/checkout");
    };

    if (loading) {
        return (
            <div className="cart-loading text-center py-5">
                <div className="spinner-border text-warning" />
                <p className="mt-3">Loading cart...</p>
            </div>
        );
    }
    return (
        <>
            <Helmet>
                <title>{meta?.title}</title>
                <meta name="description" content={meta?.metaDescription} />
                <meta name="keywords" content={meta?.keywords} />
                <link rel="canonical" href={meta?.canonicalUrl} />
                <meta name="robots" content={meta?.robots} />
            </Helmet>
            <div className="custom-container py-5">
                {cartItems && cartItems?.length > 0 ?
                    <div className="cart-page pb-5">
                        {/* Left: Cart Items */}
                        <div className="cart-left position-relative d-flex flex-column">
                            <h2>Shopping Cart</h2>
                            <div className="cart-items flex-grow-1 overflow-auto">
                                {cartItems && cartItems.map(item => (
                                    <div key={item.slug} className="cart-item">
                                        <div className="item-image-wrapper">
                                            <img src={item.image} alt={item.productName} className="item-image" />
                                        </div>
                                        <div className="item-details">
                                            <h4>{item.productName}</h4>
                                            <p className="brand">{item.brand}</p>
                                            <div className="item-attributes">
                                                {item && item.color && <span>Color: {item.color}</span>}
                                                {item && item.size && <span>Size: {item.size}</span>}
                                            </div>
                                            {/* <p className={`stock ${item.stock > 0 ? "in-stock" : "out-stock"}`}>
                                                {item.stock > 0 ? `${item.stock} left` : "Out of Stock"}
                                            </p> */}
                                        </div>
                                        <div className="item-actions">
                                            {/* <p className="price">AED {(item.price * item.qty).toFixed(2)}</p> */}
                                            {/* <div className="qty-control">
                                                <button
                                                    onClick={() => updateItem(item.slug, item.qty - 1, item.color, item.size)}
                                                >-</button>
                                                <span>{item.qty}</span>
                                                <button
                                                    onClick={() => updateItem(item.slug, item.qty + 1, item.color, item.size)}
                                                >+</button>
                                            </div> */}
                                            <button
                                                className="remove-btn"
                                                onClick={() => removeItem(item.slug, item.color, item.size)}
                                            >
                                                <Delete />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex justify-content-end py-3 border-top">
                                <button
                                    className="btn btn-lg d-flex align-items-center gap-2"
                                    style={{ backgroundColor: "#fbb100", color: "#000", borderRadius: "0" }}
                                    onClick={goToCheckout}
                                >
                                    <ShoppingBag size={16} /> Checkout
                                </button>

                                {/* <button 
                                className="checkout-btn" onClick={goToCheckout}>
                                    <ShoppingBag /> Proceed to Checkout
                                </button> */}
                            </div>
                        </div>

                        {/* Right: Order Summary */}
                        {/* <div className="cart-right">
                            <div className="order-summary">
                                <h3>Order Summary</h3>
                                <div className="summary-line">
                                    <span>Subtotal:</span>
                                    <span>AED {subtotal.toFixed(2)}</span>
                                </div>
                           <div className="summary-line">
                            <span>Shipping:</span>
                            <span>AED 10.00</span>
                        </div> 
                                <div className="summary-line total">
                                    <span>Total:</span>
                                    <span>AED {(subtotal + 10).toFixed(2)}</span>
                                </div>
                                <button className="checkout-btn" onClick={goToCheckout}>
                                    <ShoppingBag /> Proceed to Checkout
                                </button>
                            </div>
                        </div> */}
                    </div> :
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <div className="empty-cart text-center py-5">
                            <ShoppingBag style={{ fontSize: 80, color: "#ccc" }} />
                            <h2>Your cart is empty</h2>
                            <p>Looks like you haven’t added anything to your cart yet.</p>
                            <button
                                className="btn success-btn mt-3"
                                onClick={() => navigate("/")}
                            >
                                Continue Shopping
                            </button>
                        </div>
                    </div>
                }

                <ProductSlider title='Products You May Like' />
            </div>
        </>
    );
}
